import React, { Component } from 'react';
import { initialize } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadSentEmails } from './actions';
import List from './List';
import Filter from './Filter';
import Dialog from '../../../common/components/Dialog';

class SentEmailsReport extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleShowMessageText = this.handleShowMessageText.bind(this);

		this.state = {
			showMessageText: false
		};
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		let filter;
		if (this.props.parentId > 0) {
			filter = { parentId: this.props.parentId };
		} else {
			filter = { ...(this.props.pagination.filter || {}), parentId: null };
		}

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleShowMessageText(message) {
		this.setState({ showMessageText: true, messageText: message })
	}

	render() {
		const { t, parentId } = this.props;
		const { filter } = this.props.pagination;
		const messageTextDialogConfig = {
			header: t('ParentCommunication_Message'),
			body: <span dangerouslySetInnerHTML={{ __html: this.state.messageText }} />,
			onHide: () => this.setState({ showMessageText: false })
		};
		return (
			<div>
				{!parentId && <Filter onSubmit={this.handleFilterSubmit} initialValues={filter} loading={this.props.pagination.loading} />}
				<List parentId={parentId} data={this.props.data} onFetchData={this.handleListEvent} onShowMessage={(message) => this.handleShowMessageText(message)} {...this.props.pagination} />
				<Dialog config={messageTextDialogConfig} show={this.state.showMessageText} t={t} bsSize='large' />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const parentId = ownProps.parentId;
	const {
		pagination,
		entities: { sentEmails }
	} = state;

	const sentEmailsPagination = (parentId ? pagination.sentEmails[`parent-${parentId}`] : pagination.sentEmails.all) || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		parentId,
		data: sentEmailsPagination.ids.map(id => sentEmails[id]),
		pagination: sentEmailsPagination
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadSentEmails,
	resetFilter: () => reset('sentEmailsFilter'),
	initializeFilter: (data, fields) => initialize('sentEmailsFilter', data, fields)
})(withTranslation()(SentEmailsReport));